import styled from 'styled-components';

export const AccordionWrapper = styled.div`
  .title {
    cursor: pointer;
    outline: none !important;
    &::selection {
      background-color: ${props => props.theme.primary};
    }
  }

  .outer-content {
    overflow: hidden;
  }

  .inner-content {
  }
`;
